import { Link } from "react-router-dom";
import { useConfig } from "@/hooks/useConfig";

export function Footer() {
  const { config } = useConfig();
  return (
    <footer className="mt-28 bg-[#1C1917] text-[#D6CCBE]" data-testid="site-footer">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-20 sm:px-8 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-2xl font-semibold text-white">{config?.store_name || "ShansoBooks"}</p>
          <p className="mt-1 font-display text-lg text-[#C98A7E]">அகமலி கேளிர்</p>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#D6CCBE]/70">{config?.tagline}</p>
          <p className="mt-4 text-sm text-[#D6CCBE]/70">
            <a href="mailto:support@shansoai.com" className="transition-colors hover:text-white" data-testid="footer-support-email">support@shansoai.com</a>
          </p>
        </div>
        <div className="text-sm md:col-span-4">
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#C98A7E]">Buying</p>
          <ul className="space-y-2.5 text-[#D6CCBE]/80">
            <li>Ships across India · flat {config?.shipping_charge === 0 ? "free" : `₹${config?.shipping_charge}`} shipping</li>
            <li>Paperback ₹480 · Hardcover ₹635</li>
            <li>GST invoice with every order</li>
            <li>All sales final — no returns or refunds</li>
          </ul>
        </div>
        <div className="text-sm md:col-span-3">
          <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#C98A7E]">Account</p>
          <ul className="space-y-2.5 text-[#D6CCBE]/80">
            <li><Link to="/account" className="transition-colors hover:text-white" data-testid="footer-orders-link">Your orders</Link></li>
            <li><Link to="/login" className="transition-colors hover:text-white" data-testid="footer-login-link">Sign in</Link></li>
            <li><Link to="/admin" className="transition-colors hover:text-white" data-testid="footer-admin-link">Admin</Link></li>
          </ul>
          <p className="mb-5 mt-8 text-[11px] font-semibold uppercase tracking-[0.24em] text-[#C98A7E]">Help</p>
          <ul className="space-y-2.5 text-[#D6CCBE]/80">
            <li><Link to="/contact" className="transition-colors hover:text-white" data-testid="footer-contact-link">Contact us</Link></li>
            <li><Link to="/terms" className="transition-colors hover:text-white" data-testid="footer-terms-link">Terms &amp; conditions</Link></li>
            <li><Link to="/refund-policy" className="transition-colors hover:text-white" data-testid="footer-refund-link">Refund policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-[#D6CCBE]/55">
        © {new Date().getFullYear()} {config?.author_name}. Sold directly by the poet. Payments secured by Cashfree.
      </div>
    </footer>
  );
}
